module.exports = __webpack_public_path__ + "img/advertising2.7f71a706.png";